module.exports = __webpack_public_path__ + "img/gonggao.3bb60be4.png";